/*
 * @Author: duyaoyao
 * @Date: 2020-09-04 14:48:08
 * @LastEditors: duyaoyao
 * @LastEditTime: 2021-02-02 10:30:12
 */
import { getDataRetry } from './request';
export default {
  // 防伪查询
  antiQuery(params) {
    return getDataRetry(
      `/apiInterface/interface/hydra-code-h5/api/v1/fwwl/anti/fake/query`,
      params
    );
  },
};
